<template>
  <v-container fluid pa-0 h-100>
    <v-layout row wrap h-100>
      <v-flex xs3>
        <v-navigation-drawer class="drawer elevation-3 w-100" :value="true" permanent floating stateless>
          <v-tabs
            v-model="activeTab"
            color="default"
            slider-color="k-orange-linear"
            grow>
            <v-tab
              key="tab-2">
              <v-toolbar flat class="transparent">
                <v-container grid-list-lg fluid>
                  <v-layout row wrap justify-center align-center>
                    <strong>
                      Auto gestion
                    </strong>
                  </v-layout>
                </v-container>
              </v-toolbar>
            </v-tab>
            <v-tab-item
              key="config-tab-2">
              <vue-perfect-scrollbar>
                <v-expansion-panel class="config-pane" focusable :value="selfServicePanels">
                  <v-expansion-panel-content :value="1">
                    <div slot="header">TEXTOS</div>
                    <v-card>
                      <vue-perfect-scrollbar>
                        <v-card-text class="config-panel">
                          <v-layout row wrap mb-3>
                            <v-flex xs12>
                              <h4><strong>Cabecera</strong></h4>
                              <v-text-field
                                solo
                                color="black"
                                placeholder="Cabecera"
                                v-model="selfService.texts.toolbar.text"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap mb-3>
                            <v-flex xs12>
                              <h4><strong>Bienvenida</strong></h4>
                              <v-text-field
                                solo
                                color="black"
                                :placeholder="`Bienvenido al portal de auto gestion ${user.company.name}`"
                                v-model="selfService.texts.welcome.text"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap mb-3>
                            <v-flex xs12>
                              <h4><strong>Boton de pagado</strong></h4>
                              <v-text-field
                                solo
                                color="black"
                                :placeholder="`Ya pague`"
                                v-model="selfService.texts.buttons.paid.text"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap mb-3>
                            <v-flex xs12>
                              <h4><strong>Boton de pago</strong></h4>
                              <v-text-field
                                solo
                                color="black"
                                :placeholder="`Pagar ahora`"
                                v-model="selfService.texts.buttons.pay.text"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap mb-3>
                            <v-flex xs12>
                              <h4>
                                <strong>
                                  URL de pago
                                </strong>
                                <v-tooltip top>
                                  <v-icon small slot="activator">fa-info-circle</v-icon>
                                  <span>Debe ingresar un url valido ejemplo: https://ejemplo.com</span>
                                </v-tooltip>
                              </h4>
                              <v-text-field
                                solo
                                color="black"
                                :placeholder="`https://${user.company.name.toLowerCase()}.com`"
                                v-model="selfService.texts.buttons.pay.url"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap mb-3>
                            <v-flex xs12>
                              <h4><strong>Boton de compromiso</strong></h4>
                              <v-text-field
                                solo
                                color="black"
                                :placeholder="`Hacer compromiso`"
                                v-model="selfService.texts.buttons.paymentPromise.text"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap mb-3>
                            <v-flex xs12>
                              <h4><strong>Dias maximos de compromiso (maximo 7)</strong></h4>
                              <v-text-field
                                solo
                                color="black"
                                name="maxDate"
                                :placeholder="`Hacer compromiso`"
                                v-model="selfService.texts.buttons.paymentPromise.maxDate"
                                v-validate="'numeric|min_value:0|max_value:7'"
                              ></v-text-field>
                              <small class="error--text">{{ errors.first('maxDate') }}</small>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap mb-3>
                            <v-flex xs12>
                              <h4><strong>Boton de contacto</strong></h4>
                              <v-text-field
                                solo
                                color="black"
                                :placeholder="`Contactanos`"
                                v-model="selfService.texts.buttons.contact.text"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </vue-perfect-scrollbar>
                    </v-card>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content>
                    <div slot="header">BOTONES</div>
                    <v-card>
                      <vue-perfect-scrollbar>
                        <v-card-text class="config-panel">
                          <v-layout row wrap mb-3>
                            <v-flex xs12>
                              <h4><strong>Mostrar botones</strong></h4>
                              <template v-for="(button, index) in selfService.buttonsList">
                                <v-list-tile :key="`list-button-${button.name}`">
                                  <v-list-tile-action>
                                    <v-checkbox
                                      v-model="button.enabled"
                                    />
                                  </v-list-tile-action>
                                  <v-list-tile-content>
                                    <v-list-tile-title>
                                      {{ selfService.texts.buttons[button.name].text === '' ? button.text : selfService.texts.buttons[button.name].text }}
                                    </v-list-tile-title>
                                  </v-list-tile-content>
                                </v-list-tile>
                                <v-divider :key="`divider-${index}`"></v-divider>
                              </template>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap mb-3>
                            <v-flex xs12>
                              <h4><strong>Orden de los botones</strong></h4>
                              <draggable
                                class="list-group"
                                tag="ul"
                                v-model="selfService.buttonsList"
                                v-bind="dragOptions"
                                @start="dragging = true"
                                @end="dragging = false"
                              >
                                <transition-group type="transition" :name="!dragging ? 'flip-list' : null">
                                  <template
                                      v-for="btn in selfService.buttonsList">
                                    <li
                                      class="list-group-item"
                                      :key="btn.name"
                                      v-if="btn.enabled">
                                      <v-icon small class="mr-2">fa-grip-vertical</v-icon>
                                      {{ selfService.texts.buttons[btn.name].text === '' ? btn.text : selfService.texts.buttons[btn.name].text }}
                                    </li>
                                  </template>
                                </transition-group>
                              </draggable>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </vue-perfect-scrollbar>
                    </v-card>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content>
                    <div slot="header">COLORES</div>
                    <v-card>
                      <vue-perfect-scrollbar>
                        <v-card-text class="config-panel">
                          <v-layout row wrap mb-3>
                            <v-flex xs12>
                              <h4>Cabecera</h4>
                              <v-layout row wrap>
                                <v-flex md12>
                                  <v-layout row wrap>
                                    <v-flex xs10 class="justify-space-between" style="display:flex;">
                                      <div
                                        class="color-dot"
                                        v-for="(color, index) in colorList"
                                        :key="`dot-${index}`"
                                        :class="{ 'active': selfService.colors.toolbar.bg.hex === `#${color}` }"
                                        :style="{ 'background': `#${color}` }"
                                        @click="setColor('selfService', color, 'toolbar', 'bg')">
                                      </div>
                                    </v-flex>
                                    <v-flex xs2>
                                      <v-menu
                                        offset-y
                                        full-width
                                        content-class="color-menu"
                                        :close-on-content-click="false"
                                        v-model="mainColorMenu">
                                        <svg slot="activator" style="display: block;margin: 2px auto" xmlns="http://www.w3.org/2000/svg" width="12.999" height="13" viewBox="0 0 12.999 13">
                                          <path id="Icon_ionic-md-color-filter" data-name="Icon ionic-md-color-filter" d="M17.289,6.4,15.6,4.709a.721.721,0,0,0-1.019,0L12.327,6.964,10.935,5.582,9.916,6.6l1.026,1.026L4.5,14.069V17.5H7.929l6.442-6.442L15.4,12.082l1.019-1.019L15.028,9.675l2.255-2.255A.719.719,0,0,0,17.289,6.4ZM7.33,16.056,5.942,14.668l5.819-5.819,1.388,1.388Z" transform="translate(-4.5 -4.498)" fill="#ff5f62"/>
                                        </svg>
                                        <sketch-picker v-model="selfService.colors.toolbar.bg" />
                                      </v-menu>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12>
                              <h4>Texto Cabecera</h4>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-layout row wrap>
                                    <v-flex xs10 class="justify-space-between" style="display:flex;">
                                      <div
                                        class="color-dot"
                                        v-for="(color, index) in colorList"
                                        :key="`dot-${index}`"
                                        :class="{ 'active': selfService.colors.toolbar.text.hex === `#${color}` }"
                                        :style="{ 'background': `#${color}` }"
                                        @click="setColor('selfService',color, 'toolbar', 'text')">
                                      </div>
                                    </v-flex>
                                    <v-flex xs2>
                                      <v-menu
                                        offset-y
                                        full-width
                                        content-class="color-menu"
                                        :close-on-content-click="false"
                                        v-model="mainTextColorMenu">
                                        <svg slot="activator" style="display: block;margin: 2px auto" xmlns="http://www.w3.org/2000/svg" width="12.999" height="13" viewBox="0 0 12.999 13">
                                          <path id="Icon_ionic-md-color-filter" data-name="Icon ionic-md-color-filter" d="M17.289,6.4,15.6,4.709a.721.721,0,0,0-1.019,0L12.327,6.964,10.935,5.582,9.916,6.6l1.026,1.026L4.5,14.069V17.5H7.929l6.442-6.442L15.4,12.082l1.019-1.019L15.028,9.675l2.255-2.255A.719.719,0,0,0,17.289,6.4ZM7.33,16.056,5.942,14.668l5.819-5.819,1.388,1.388Z" transform="translate(-4.5 -4.498)" fill="#ff5f62"/>
                                        </svg>
                                        <sketch-picker v-model="selfService.colors.toolbar.text" />
                                      </v-menu>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-divider></v-divider>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <h4>Botones y dialogos</h4>
                              <v-layout row wrap>
                                <v-flex md12>
                                  <v-layout row wrap>
                                    <v-flex xs10 class="justify-space-between" style="display:flex;">
                                      <div
                                        class="color-dot"
                                        v-for="(color, index) in colorList"
                                        :key="`dot-${index}`"
                                        :class="{ 'active': selfService.colors.buttons.all.bg.hex === `#${color}` }"
                                        :style="{ 'background': `#${color}` }"
                                        @click="setButtonColors('selfService', color, 'buttons', 'all', 'bg')">
                                      </div>
                                    </v-flex>
                                    <v-flex xs2>
                                      <v-menu
                                        offset-y
                                        full-width
                                        content-class="color-menu"
                                        :close-on-content-click="false"
                                        v-model="buttonColorMenu">
                                        <svg slot="activator" style="display: block;margin: 2px auto" xmlns="http://www.w3.org/2000/svg" width="12.999" height="13" viewBox="0 0 12.999 13">
                                          <path id="Icon_ionic-md-color-filter" data-name="Icon ionic-md-color-filter" d="M17.289,6.4,15.6,4.709a.721.721,0,0,0-1.019,0L12.327,6.964,10.935,5.582,9.916,6.6l1.026,1.026L4.5,14.069V17.5H7.929l6.442-6.442L15.4,12.082l1.019-1.019L15.028,9.675l2.255-2.255A.719.719,0,0,0,17.289,6.4ZM7.33,16.056,5.942,14.668l5.819-5.819,1.388,1.388Z" transform="translate(-4.5 -4.498)" fill="#ff5f62"/>
                                        </svg>
                                        <sketch-picker v-model="selfService.colors.buttons.all.bg" />
                                      </v-menu>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12>
                              <h4>Texto de botones y dialogos</h4>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <v-layout row wrap>
                                    <v-flex xs10 class="justify-space-between" style="display:flex;">
                                      <div
                                        class="color-dot"
                                        v-for="(color, index) in colorList"
                                        :key="`dot-${index}`"
                                        :class="{ 'active': selfService.colors.buttons.all.text.hex === `#${color}` }"
                                        :style="{ 'background': `#${color}` }"
                                        @click="setButtonColors('selfService', color, 'buttons', 'all', 'text')">
                                      </div>
                                    </v-flex>
                                    <v-flex xs2>
                                      <v-menu
                                        offset-y
                                        full-width
                                        content-class="color-menu"
                                        :close-on-content-click="false"
                                        v-model="buttonTextColorMenu">
                                        <svg slot="activator" style="display: block;margin: 2px auto" xmlns="http://www.w3.org/2000/svg" width="12.999" height="13" viewBox="0 0 12.999 13">
                                          <path id="Icon_ionic-md-color-filter" data-name="Icon ionic-md-color-filter" d="M17.289,6.4,15.6,4.709a.721.721,0,0,0-1.019,0L12.327,6.964,10.935,5.582,9.916,6.6l1.026,1.026L4.5,14.069V17.5H7.929l6.442-6.442L15.4,12.082l1.019-1.019L15.028,9.675l2.255-2.255A.719.719,0,0,0,17.289,6.4ZM7.33,16.056,5.942,14.668l5.819-5.819,1.388,1.388Z" transform="translate(-4.5 -4.498)" fill="#ff5f62"/>
                                        </svg>
                                        <sketch-picker v-model="selfService.colors.buttons.all.text" />
                                      </v-menu>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </vue-perfect-scrollbar>
                    </v-card>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content>
                    <div slot="header">INFORMACIÓN</div>
                    <v-card>
                      <vue-perfect-scrollbar>
                        <v-card-text class="config-panel">
                          <v-layout row wrap mb-3>
                            <v-flex xs12>
                              <h4><strong>Instrucciones de pago</strong></h4>
                              <v-text-field
                                solo
                                readonly
                                color="black"
                                :placeholder="`Instrucciones de pago`"
                                :value="selfService.texts.buttons.pay.instructions !== '' ? selfService.texts.buttons.pay.instructions.replace(/(<([^>]+)>)/ig,'') : selfService.texts.buttons.pay.instructions"
                                @focus="show = true"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-divider></v-divider>
                          <v-layout row wrap mb-3>
                            <v-flex xs12>
                              <h4>
                                <strong>
                                  Teléfono de contacto
                                </strong>
                                <v-tooltip top>
                                  <v-icon small slot="activator">fa-info-circle</v-icon>
                                  <span>Debe ingresar el numero de telefono con codigo internacional: 56912345678</span>
                                </v-tooltip>
                              </h4>
                              <v-text-field
                                solo
                                color="black"
                                :placeholder="`Instrucciones de pago`"
                                v-model ="selfService.texts.buttons.contact.phone"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap mb-3>
                            <v-flex xs12>
                              <h4>
                                <strong>
                                  ¿El Teléfono es para whatsapp?
                                </strong>
                              </h4>
                              <v-switch
                                :label="selfService.texts.buttons.contact.isWp ? 'No' : 'Si'"
                                v-model="selfService.texts.buttons.contact.isWp"
                              ></v-switch>
                            </v-flex>
                          </v-layout>
                          <v-divider></v-divider>
                          <v-layout row wrap mb-3>
                            <v-flex xs12>
                              <h4>
                                <strong>
                                  Email de contacto
                                </strong>
                                <v-tooltip top>
                                  <v-icon small slot="activator">fa-info-circle</v-icon>
                                  <span>Debe ingresar un email valido ejemplo: ejemplo@dominio.com</span>
                                </v-tooltip>
                              </h4>
                              <v-text-field
                                solo
                                color="black"
                                :placeholder="`Email de contacto`"
                                v-model ="selfService.texts.buttons.contact.email"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-divider></v-divider>
                          <v-layout row wrap mb-3>
                            <v-flex xs12>
                              <h4><strong>Dirección</strong></h4>
                              <v-text-field
                                solo
                                color="black"
                                :placeholder="`Dirección`"
                                v-model ="selfService.texts.buttons.contact.address"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </vue-perfect-scrollbar>
                    </v-card>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content>
                    <div slot="header">LOGO</div>
                    <v-card>
                      <vue-perfect-scrollbar>
                        <v-card-text class="config-panel">
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-layout row wrap mb-3>
                                <v-flex xs12>
                                  <h4>
                                    <strong>Posicion del logo</strong>
                                    <v-tooltip top>
                                      <v-icon small slot="activator">fa-info-circle</v-icon>
                                      <span>El logo no se alineara al centro la cabecera posee texto.</span>
                                    </v-tooltip>
                                  </h4>
                                  <v-select
                                    solo
                                    color="black"
                                    :items="ablePositions"
                                    item-value="value"
                                    item-text="text"
                                    v-model="selfService.logo.position"
                                  ></v-select>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-divider></v-divider>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <span class="mb-3">Se recomienda que las dimensiones de la imagen sea 50x50</span>
                              <div class="dropbox">
                                <v-btn icon class="close k-orange-linear" v-if="previewFile !== '' || companyLogo" @click="clearFile">
                                  <v-icon>fa-times</v-icon>
                                </v-btn>
                                <span class="caption text-xs-center">
                                  <template v-if="previewFile === '' && !companyLogo">
                                    Arrastre o click aquí para agregar el logo
                                  </template>
                                  <template v-else>
                                    1 elemento seleccionado.
                                  </template>
                                  <img :src="previewFile || companyLogo" v-if="previewFile !== '' || companyLogo" style="width: 50px;">
                                </span>
                                <input ref="fileupload" type="file" @change="filesChange">
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </vue-perfect-scrollbar>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </vue-perfect-scrollbar>
            </v-tab-item>
            <!-- <v-tab
              ripple
              key="tab-1">
              <v-toolbar flat class="transparent">
                <v-container grid-list-lg fluid>
                  <v-layout row wrap justify-center align-center>
                    <strong>
                      Chatbot
                    </strong>
                  </v-layout>
                </v-container>
              </v-toolbar>
            </v-tab>
            <v-tab-item
              key="config-tab-1">
              <v-container grid-list-lg pa-0>
                <v-expansion-panel focusable :value="chatbotPanels">
                  <v-expansion-panel-content :value="1">
                    <div slot="header">TEXTOS</div>
                    <v-card>
                      <v-card-text>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <h4><strong>Cabecera</strong></h4>
                            <v-text-field
                              solo
                              color="black"
                              :placeholder="`Chatbot ${user.company.name}`"
                              v-model="form.texts.toolbar.text"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <h4><strong>Nombre del bot</strong></h4>
                            <v-text-field
                              solo
                              color="black"
                              :placeholder="`Booty`"
                              v-model="form.texts.botname.text"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <h4>
                              <strong>
                                URL de pago
                              </strong>
                              <v-tooltip top>
                                <v-icon small slot="activator">fa-info-circle</v-icon>
                                <span>Debe ingresar un url valido ejemplo: https://ejemplo.com</span>
                              </v-tooltip>
                            </h4>
                            <v-text-field
                              solo
                              color="black"
                              :placeholder="`https://${user.company.name.toLowerCase()}.com`"
                              v-model="form.texts.url.text"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content>
                    <div slot="header">COLORES</div>
                    <v-card>
                      <v-card-text>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <h4>Cabecera</h4>
                            <v-layout row wrap>
                              <v-flex md12>
                                <v-layout row wrap>
                                  <v-flex xs10 class="justify-space-between" style="display:flex;">
                                    <div
                                      class="color-dot"
                                      v-for="(color, index) in colorList"
                                      :key="`dot-${index}`"
                                      :class="{ 'active': form.colors.toolbar.bg.hex === `#${color}` }"
                                      :style="{ 'background': `#${color}` }"
                                      @click="setColor('form', color, 'toolbar', 'bg')">
                                    </div>
                                  </v-flex>
                                  <v-flex xs2>
                                    <v-menu
                                      offset-y
                                      full-width
                                      content-class="color-menu"
                                      :close-on-content-click="false"
                                      v-model="mainColorMenu">
                                      <svg slot="activator" xmlns="http://www.w3.org/2000/svg" width="12.999" height="13" viewBox="0 0 12.999 13">
                                        <path id="Icon_ionic-md-color-filter" data-name="Icon ionic-md-color-filter" d="M17.289,6.4,15.6,4.709a.721.721,0,0,0-1.019,0L12.327,6.964,10.935,5.582,9.916,6.6l1.026,1.026L4.5,14.069V17.5H7.929l6.442-6.442L15.4,12.082l1.019-1.019L15.028,9.675l2.255-2.255A.719.719,0,0,0,17.289,6.4ZM7.33,16.056,5.942,14.668l5.819-5.819,1.388,1.388Z" transform="translate(-4.5 -4.498)" fill="#ff5f62"/>
                                      </svg>
                                      <sketch-picker v-model="form.colors.toolbar.bg" />
                                    </v-menu>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12>
                            <h4>Texto Cabecera</h4>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <v-layout row wrap>
                                  <v-flex xs10 class="justify-space-between" style="display:flex;">
                                    <div
                                      class="color-dot"
                                      v-for="(color, index) in colorList"
                                      :key="`dot-${index}`"
                                      :class="{ 'active': form.colors.toolbar.text.hex === `#${color}` }"
                                      :style="{ 'background': `#${color}` }"
                                      @click="setColor('form', color, 'toolbar', 'text')">
                                    </div>
                                  </v-flex>
                                  <v-flex xs2>
                                    <v-menu
                                      offset-y
                                      full-width
                                      content-class="color-menu"
                                      :close-on-content-click="false"
                                      v-model="mainTextColorMenu">
                                      <svg slot="activator" xmlns="http://www.w3.org/2000/svg" width="12.999" height="13" viewBox="0 0 12.999 13">
                                        <path id="Icon_ionic-md-color-filter" data-name="Icon ionic-md-color-filter" d="M17.289,6.4,15.6,4.709a.721.721,0,0,0-1.019,0L12.327,6.964,10.935,5.582,9.916,6.6l1.026,1.026L4.5,14.069V17.5H7.929l6.442-6.442L15.4,12.082l1.019-1.019L15.028,9.675l2.255-2.255A.719.719,0,0,0,17.289,6.4ZM7.33,16.056,5.942,14.668l5.819-5.819,1.388,1.388Z" transform="translate(-4.5 -4.498)" fill="#ff5f62"/>
                                      </svg>
                                      <sketch-picker v-model="form.colors.toolbar.text" />
                                    </v-menu>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                        <v-divider></v-divider>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <h4>Botones y dialogos</h4>
                            <v-layout row wrap>
                              <v-flex md12>
                                <v-layout row wrap>
                                  <v-flex xs10 class="justify-space-between" style="display:flex;">
                                    <div
                                      class="color-dot"
                                      v-for="(color, index) in colorList"
                                      :key="`dot-${index}`"
                                      :class="{ 'active': form.colors.buttons.bg.hex === `#${color}` }"
                                      :style="{ 'background': `#${color}` }"
                                      @click="setColor('form', color, 'buttons', 'bg')">
                                    </div>
                                  </v-flex>
                                  <v-flex xs2>
                                    <v-menu
                                      offset-y
                                      full-width
                                      content-class="color-menu"
                                      :close-on-content-click="false"
                                      v-model="buttonColorMenu">
                                      <svg slot="activator" xmlns="http://www.w3.org/2000/svg" width="12.999" height="13" viewBox="0 0 12.999 13">
                                        <path id="Icon_ionic-md-color-filter" data-name="Icon ionic-md-color-filter" d="M17.289,6.4,15.6,4.709a.721.721,0,0,0-1.019,0L12.327,6.964,10.935,5.582,9.916,6.6l1.026,1.026L4.5,14.069V17.5H7.929l6.442-6.442L15.4,12.082l1.019-1.019L15.028,9.675l2.255-2.255A.719.719,0,0,0,17.289,6.4ZM7.33,16.056,5.942,14.668l5.819-5.819,1.388,1.388Z" transform="translate(-4.5 -4.498)" fill="#ff5f62"/>
                                      </svg>
                                      <sketch-picker v-model="form.colors.buttons.bg" />
                                    </v-menu>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs12>
                            <h4>Texto de botones y dialogos</h4>
                            <v-layout row wrap>
                              <v-flex xs12>
                                <v-layout row wrap>
                                  <v-flex xs10 class="justify-space-between" style="display:flex;">
                                    <div
                                      class="color-dot"
                                      v-for="(color, index) in colorList"
                                      :key="`dot-${index}`"
                                      :class="{ 'active': form.colors.buttons.text.hex === `#${color}` }"
                                      :style="{ 'background': `#${color}` }"
                                      @click="setColor('form', color, 'buttons', 'text')">
                                    </div>
                                  </v-flex>
                                  <v-flex xs2>
                                    <v-menu
                                      offset-y
                                      full-width
                                      content-class="color-menu"
                                      :close-on-content-click="false"
                                      v-model="buttonTextColorMenu">
                                      <svg slot="activator" xmlns="http://www.w3.org/2000/svg" width="12.999" height="13" viewBox="0 0 12.999 13">
                                        <path id="Icon_ionic-md-color-filter" data-name="Icon ionic-md-color-filter" d="M17.289,6.4,15.6,4.709a.721.721,0,0,0-1.019,0L12.327,6.964,10.935,5.582,9.916,6.6l1.026,1.026L4.5,14.069V17.5H7.929l6.442-6.442L15.4,12.082l1.019-1.019L15.028,9.675l2.255-2.255A.719.719,0,0,0,17.289,6.4ZM7.33,16.056,5.942,14.668l5.819-5.819,1.388,1.388Z" transform="translate(-4.5 -4.498)" fill="#ff5f62"/>
                                      </svg>
                                      <sketch-picker v-model="form.colors.buttons.text" />
                                    </v-menu>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                  <v-expansion-panel-content>
                    <div slot="header">AVATAR</div>
                    <v-card>
                      <v-card-text>
                        <span class="mb-3">Se recomienda que las dimensiones de la imagen sea 50x50</span>
                        <div class="dropbox">
                          <v-btn icon class="close k-orange-linear" v-if="previewFile !== '' || avatar" @click="clearFile">
                            <v-icon>fa-times</v-icon>
                          </v-btn>
                          <span class="caption text-xs-center">
                            <template v-if="previewFile === ''">
                              Arrastre o click aquí para agregar el avatar
                            </template>
                            <template v-else>
                              1 elemento seleccionado.
                            </template>
                            <img :src="previewFile" v-if="previewFile !== ''" style="width: 50px;">
                          </span>
                          <input ref="fileupload" type="file" @change="filesChange">
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-container>
            </v-tab-item> -->
          </v-tabs>
          <v-card-actions class="drawer-action w-100">
            <v-btn
              color="success"
              class="d-block ml-auto"
              @click="sendConfig"
              :disabled="sending ||
                (isNaN(selfService.texts.buttons.paymentPromise.maxDate) && selfService.texts.buttons.paymentPromise.maxDate !== '') ||
                (selfService.texts.buttons.paymentPromise.maxDate !== '' && (selfService.texts.buttons.paymentPromise.maxDate < 0 || selfService.texts.buttons.paymentPromise.maxDate > 7))">Guardar</v-btn>
          </v-card-actions>
        </v-navigation-drawer>
      </v-flex>
      <v-flex xs9 class="position-relative">
        <div class="phone-container d-flex align-center h-100">
          <svg class="phone" id="XMLID_52_" xmlns="http://www.w3.org/2000/svg" width="300" height="568.117" viewBox="0 0 284.85 568.117">
            <path id="XMLID_158_" d="M307.816,74.955H285.265c-4.827,0-6.567-.633-6.884,5.46a11.488,11.488,0,0,1-3.165,7.517,17.159,17.159,0,0,1-7.359,4.589,21.53,21.53,0,0,1-6.33,1.345H157.4a21.634,21.634,0,0,1-6.33-1.424,17.437,17.437,0,0,1-7.359-4.589,11.271,11.271,0,0,1-3.165-7.517c-.316-6.093-2.057-5.539-6.884-5.539H110.874C97.027,74.955,85,84.766,85,98.534V583.807c0,13.847,12.027,26.032,25.795,26.032H307.816c13.847,0,24.054-12.185,24.054-26.032V98.534C331.87,84.766,321.663,74.955,307.816,74.955Z" transform="translate(-65.219 -59.921)" fill="none"/>
            <path id="XMLID_156_" d="M341.685,184.974V96.037C341.685,73.249,323.961,56,301.173,56H104.31C81.522,56,62.374,73.328,62.374,96.037v34.34H60v21.364h2.374v19.781H60v40.354h2.374v11.869H60V264.1h2.374V581.706c0,22.788,19.227,42.411,41.936,42.411H301.173c22.788,0,40.512-19.623,40.512-42.411V250.647h3.165V184.974ZM235.895,73.8a3.481,3.481,0,1,1-3.481-3.481A3.512,3.512,0,0,1,235.895,73.8Zm-47.079-.4h30.859a2.011,2.011,0,1,1,0,3.956H188.815a2.011,2.011,0,1,1,0-3.956ZM326.651,579.886c0,13.847-10.207,26.032-24.054,26.032H105.576c-13.847,0-25.795-12.185-25.795-26.032V94.613c0-13.768,12.027-23.579,25.795-23.579h22.788c4.827,0,6.567-.712,6.884,5.38a11.872,11.872,0,0,0,3.165,7.6,17.3,17.3,0,0,0,7.359,4.668,21.529,21.529,0,0,0,6.33,1.345H256.151a21.749,21.749,0,0,0,6.33-1.5,17.307,17.307,0,0,0,7.359-4.51A10.913,10.913,0,0,0,273,76.572c.316-6.093,2.057-5.618,6.884-5.618h22.551c13.847,0,24.054,9.811,24.054,23.579V579.886Z" transform="translate(-60 -56)" fill="#494949"/>
            <path id="XMLID_159_" d="M253.032,78H222.174a2.011,2.011,0,1,0,0,3.956h30.859a2.122,2.122,0,0,0,2.374-1.978A2.167,2.167,0,0,0,253.032,78Z" transform="translate(-93.358 -60.593)" fill="#f2f2f2"/>
            <circle id="XMLID_51_" cx="3.481" cy="3.481" r="3.481" transform="translate(168.932 14.322)" fill="#f2f2f2"/>
          </svg>
          <v-layout column wrap class="chat-content">
            <v-flex class="d-flex" v-if="activeTab === '0'" style="flex-direction: column">
              <v-toolbar class="py-2"
                :class="{ 'k-orange-linear': selfService.colors.toolbar.bg.hex === '', 'white--text': selfService.colors.toolbar.text.hex === '' }"
                :style="toolbarStyle">
                <v-toolbar-title
                  class="w-100"
                  :class="{
                    'position-left': selfService.logo.position === 'left' || (selfService.logo.position === 'center' && selfService.texts.toolbar.text !== ''),
                    'position-center': selfService.logo.position === 'center' && selfService.texts.toolbar.text === '',
                    'position-right': selfService.logo.position === 'right',
                  }">
                  <img
                    :src="previewFile !== '' ? previewFile : logo"
                    class="logo">
                  <span>
                    {{ selfService.texts.toolbar.text }}
                  </span>
                </v-toolbar-title>
              </v-toolbar>
              <v-layout row wrap class="chat-container self-service">
                <v-flex xs12>
                  <v-card class="h-100">
                    <v-card-text class="pa-3">
                      <v-layout row wrap :class="{ 'not-visible': activeBtn !== ''}">
                        <v-flex>
                          <h3 class="text-xs-center">{{ selfService.texts.welcome.text || `Bienvenido al sistema de autogestion de ${user.company.name}`}}</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap justify-center align-center>
                        <v-flex v-if="activeBtn === ''">
                          <v-layout row wrap v-for="(btn, index) in selfService.buttonsList" :key="`button-${index}`">
                            <v-flex xs12>
                              <v-btn
                              class="big-button"
                              :class="buttonClasses"
                              :style="buttonsStyle"
                              ripple
                              block
                              v-if="btn.enabled"
                              @click="setActiveBtn(btn.name)">{{ selfService.texts.buttons[btn.name].text === '' ? btn.text : selfService.texts.buttons[btn.name].text }}</v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex v-else>
                          <v-layout row wrap v-if="activeBtn === 'paid'">
                            <v-flex xs12>
                              <v-icon
                                class="big-icon d-block my-3 text-xs-center k-orange-linear-text">
                                far fa-check-circle
                              </v-icon>
                              <div>
                                <p class="text-xs-center mb-3">
                                  Entendido, marcaremos este caso como equivocado.
                                </p>
                              </div>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap v-if="activeBtn === 'pay'">
                            <v-flex xs12>
                              <template
                                v-if="selfService.texts.buttons.pay.instructions !== ''"
                                >
                                <div v-html="selfService.texts.buttons.pay.instructions" class="ql-editor">
                                </div>
                              </template>
                              <template v-else>
                                <div class="text-xs-center my-4">
                                  <template v-if="selfService.texts.buttons.pay.url">
                                    Click <a :href="selfService.texts.buttons.pay.url">aquí</a> para ir a la pagina web.
                                  </template>
                                  <template v-else>
                                    No existen instrucciones de pago.
                                  </template>
                                </div>
                              </template>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap v-if="activeBtn === 'paymentPromise'">
                            <v-flex xs12>
                              <v-icon
                                class="big-icon d-block my-3 text-xs-center k-orange-linear-text">
                                far fa-check-circle
                              </v-icon>
                              <div>
                                <p class="text-xs-center mb-3">
                                  Gracias por agendar y confirmar la fecha de compromiso
                                </p>
                              </div>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap v-if="activeBtn === 'contact'">
                            <v-flex xs12>
                              <h3 class="text-xs-center">Contacto</h3>
                              <v-layout row wrap v-if="selfService.texts.buttons.contact.phone !== ''">
                                <v-flex xs12 class="text-xs-center">
                                  <v-icon
                                    class="d-block mt-2"
                                    :color="selfService.colors.buttons.all.bg.hex">
                                    {{ selfService.texts.buttons.contact.isWp ? 'fab fa-whatsapp' : 'fas fa-phone' }}
                                  </v-icon>
                                  <p class="d-block my-2">
                                    {{ selfService.texts.buttons.contact.phone }}
                                  </p>
                                  <v-btn
                                    flat
                                    round
                                    outline
                                    class="k-orange-linear-text normal-button"
                                    :href="`https://wa.me/${selfService.texts.buttons.contact.phone}`">
                                    Contactar ahora
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                              <v-layout row wrap v-if="selfService.texts.buttons.contact.email !== ''">
                                <v-flex xs12 class="text-xs-center">
                                  <v-icon
                                    class="d-block mt-2"
                                    :color="selfService.colors.buttons.all.bg.hex">
                                    fas fa-envelope
                                  </v-icon>
                                  <p class="d-block my-2">
                                    {{ selfService.texts.buttons.contact.email }}
                                  </p>
                                  <v-btn
                                    flat
                                    round
                                    outline
                                    class="k-orange-linear-text normal-button">
                                    Enviar email
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                              <v-layout row wrap v-if="selfService.texts.buttons.contact.address !== ''">
                                <v-flex xs12 class="text-xs-center">
                                  <v-icon
                                    class="d-block mt-2"
                                    :color="selfService.colors.buttons.all.bg.hex">
                                    fas fa-street-view
                                  </v-icon>
                                  <p class="d-block my-2">
                                    {{ selfService.texts.buttons.contact.address }}
                                  </p>
                                </v-flex>
                              </v-layout>
                              <v-layout row wrap
                                v-if="selfService.texts.buttons.contact.phone === '' &&
                                  selfService.texts.buttons.contact.email === '' &&
                                  selfService.texts.buttons.contact.address === ''">
                                <v-flex xs12 class="text-xs-center">
                                  <p class="d-block my-2">
                                    Sin información de contacto.
                                  </p>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap>
                            <v-flex xs12 class="text-xs-center">
                              <v-btn
                                class="position-relative normal-button"
                                :class="buttonClasses"
                                :style="buttonsStyle"
                                ripple
                                @click="activeBtn = ''">Volver</v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex v-else>
              <v-toolbar class="py-2" :class="{ 'k-orange-linear': form.colors.toolbar.bg.hex === '', 'white--text': form.colors.toolbar.text.hex === '' }" :style="toolbarStyle">
                <v-toolbar-title>
                  <v-avatar
                    :size="25"
                    color="grey"
                    class="pa-3 mr-1">
                    <img :src="previewFile !== '' ? previewFile : defaultAvatar">
                  </v-avatar>
                  {{ form.texts.toolbar.text ? form.texts.toolbar.text : `Chatbot ${user.company.name}` }}
                </v-toolbar-title>
              </v-toolbar>
              <v-layout row wrap class="chat-container">
                <v-flex xs12>
                  <v-card class="h-100">
                    <v-card-text class="chat-room--list pa-3">
                      <template v-for="(message, index) in messages">
                        <v-layout row :class="{'mb-3': true, reverse: !message.origin}" :key="`message-${index}`">
                          <v-avatar
                            v-if="message.origin"
                            :size="25"
                            class="mt-auto"
                            color="grey">
                            <img :src="previewFile !== '' ? previewFile : defaultAvatar">
                          </v-avatar>
                          <div class="mx-2 mt-auto">
                            <div>
                              <div
                                :class="{
                                  reverse: !message.origin,
                                  'px-3 mb-0 py-2 message-chip d-inline-block': true,
                                  'mr-auto grey': message.origin,
                                  'ml-auto float-right': !message.origin,
                                  'k-orange-linear': !message.origin && form.colors.buttons.bg.hex === '',
                                  'white--text': !message.origin && form.colors.buttons.text.hex === '',
                                  'message-chip-bg': !message.origin && form.colors.buttons.bg.hex !== '',
                                  'message-chip-text': !message.origin && form.colors.buttons.text.hex !== '' }"
                                  :style="buttonsStyle"
                                v-html="message.text">
                              </div>
                              <div :class="{'clearfix': true, 'text-xs-right': !message.origin, 'text-xs-left ml-2': message.origin}">
                                <small class="caption text--secondary mt-1">
                                  {{ message.created_at | formatDate }}
                                </small>
                              </div>
                            </div>
                          </div>
                        </v-layout>
                      </template>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="position-relative" id="chat-actions" ref="chatActions">
                <small class="writing">
                  {{ form.texts.botname.text ? form.texts.botname.text : 'Booty' }} esta escribiendo
                  <span class="dot" v-for="i in 3" :key="`dot${i}`"></span>
                </small>
                <v-flex xs12 class="py-2">
                  <template>
                      <v-chip
                        :class="{
                          'k-orange-linear': form.colors.buttons.bg.hex === '',
                          'white--text': form.colors.buttons.text.hex === '',
                          'message-chip-bg': form.colors.buttons.bg.hex !== '',
                          'message-chip-text': form.colors.buttons.text.hex !== '' }"
                          :style="buttonsStyle">
                        <component
                          :is="form.texts.url.text !== '' ? 'a' : 'span'"
                          :href="form.texts.url.text !== '' ? form.texts.url.text : '#!'"
                          target="_blank"
                          class="chip-link"
                          :class="{
                            'k-orange-linear': form.colors.buttons.bg.hex === '',
                            'white--text': form.colors.buttons.text.hex === '',
                            'message-chip-text': form.colors.buttons.text.hex !== ''
                          }">
                          Pagar ahora
                        </component>
                      </v-chip>
                  </template>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
    <dialog-editor
      :show="show"
      :value="selfService.texts.buttons.pay.instructions"
      :text.sync="selfService.texts.buttons.pay.instructions"
      @close="show = false">
    </dialog-editor>
    <v-snackbar
      :top="true"
      :right="true"
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </v-container>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import moment from 'moment';
import { Sketch } from 'vue-color';
import DialogEditor from '@/components/global/DialogEditor';
import { VueEditor, Quill } from 'vue2-editor';
import draggable from 'vuedraggable';

const now = moment.utc();
const form = {
  colors: {
    toolbar: {
      bg: {
        hex: '',
      },
      text: {
        hex: '',
      },
    },
    buttons: {
      bg: {
        hex: '',
      },
      text: {
        hex: '',
      },
    },
  },
  texts: {
    toolbar: {
      text: '',
    },
    botname: {
      text: '',
    },
    url: {
      text: '',
    },
  },
  avatar: {
    file: {},
  },
};
const selfService = {
  colors: {
    toolbar: {
      bg: {
        hex: '',
      },
      text: {
        hex: '',
      },
    },
    buttons: {
      all: {
        bg: {
          hex: '',
        },
        text: {
          hex: '',
        },
      },
      paid: {
        bg: {
          hex: '',
        },
        text: {
          hex: '',
        },
      },
      pay: {
        bg: {
          hex: '',
        },
        text: {
          hex: '',
        },
      },
      paymentPromise: {
        bg: {
          hex: '',
        },
        text: {
          hex: '',
        },
      },
      contact: {
        bg: {
          hex: '',
        },
        text: {
          hex: '',
        },
      },
    },
  },
  texts: {
    toolbar: {
      text: '',
    },
    welcome: {
      text: '',
    },
    buttons: {
      paid: {
        text: '',
      },
      pay: {
        text: '',
        url: '',
        instructions: '',
      },
      paymentPromise: {
        text: '',
        maxDate: '',
      },
      contact: {
        text: '',
        phone: '',
        email: '',
        address: '',
        isWp: false,
      },
    },
  },
  logo: {
    position: 'left',
  },
  buttonsList: [
    {
      id: 1,
      name: 'paid',
      text: 'Ya pague',
      enabled: true,
    },
    {
      id: 2,
      name: 'pay',
      text: 'Pagar ahora',
      enabled: true,
    },
    {
      id: 3,
      name: 'paymentPromise',
      text: 'Pagar luego',
      enabled: true,
    },
    {
      id: 4,
      name: 'contact',
      text: 'Contactanos',
      enabled: true,
    },
  ],
};
export default {
  inject: ['$validator'],
  created() {
    this.axios.get('self-service/config').then(({ data }) => {
      if (data.chatbot) {
        this.form = JSON.parse(data.chatbot.config);
        this.avatar = data.chatbot.avatar;
      }
      if (data.selfService) {
        this.selfService = JSON.parse(data.selfService.config);
        this.companyLogo = data.selfService.avatar;
      }
    });
  },
  components: {
    'sketch-picker': Sketch,
    VuePerfectScrollbar,
    DialogEditor,
    draggable,
    VueEditor,
    Quill,
  },
  data() {
    return {
      show: false,
      showContact: false,
      sending: false,
      snackbar: {
        color: '',
        text: '',
        show: false,
      },
      chat: {
        chatCenterMessages: [
          {
            origin: 1,
            text: `Hola, soy tu asistente virtual de ${this.$auth.user().company.name}, Eres John`,
            created_at: now,
          },
          {
            origin: 0,
            text: 'Si',
            created_at: now,
          },
        ],
      },
      form,
      selfService,
      colorList: [
        '474747',
        'fe6a6e',
        '24cf01',
        '1591e5',
        'dede02',
        'e81616',
        'c6c6c6',
        '26e2c5',
      ],
      positions: [
        {
          value: 'left',
          text: 'Izquierda',
        },
        {
          value: 'center',
          text: 'Centro',
        },
        {
          value: 'right',
          text: 'Derecha',
        },
      ],
      dragging: false,
      chatbotPanels: '1',
      selfServicePanels: '1',
      companyLogo: null,
      avatar: {},
      activeTab: '0',
      previewFile: '',
      defaultAvatar: 'https://img.icons8.com/ios/50/000000/user-male.png',
      mainColorMenu: false,
      buttonColorMenu: false,
      mainTextColorMenu: false,
      buttonTextColorMenu: false,
      paymentPromise: '',
      answers: [
        'Pagar ahora',
        'Agendar compromiso',
        'No puedo pagar ahora',
      ],
      datePickerDialog: false,
      activeBtn: '',
    };
  },
  computed: {
    messages() {
      let messages = [];
      messages = this.chat.chatCenterMessages.sort((a, b) => (a.id < b.id ? -1 : 1));
      return messages;
    },
    user() {
      return this.$auth.user();
    },
    toolbarStyle() {
      const tmp = this.activeTab === '0' ? 'selfService' : 'form';
      const styles = [];
      const bg = this[tmp].colors.toolbar.bg.hex;
      const text = this[tmp].colors.toolbar.text.hex;
      const result = this.getStyles('toolbar', bg, text);
      styles.push(...result);
      return styles;
    },
    buttonsStyle() {
      if (this.activeTab === '0') {
        const styles = [];
        const bg = this.selfService.colors.buttons.all.bg.hex;
        const text = this.selfService.colors.buttons.all.text.hex;
        const result = this.getStyles('buttons', bg, text);
        styles.push(...result);
        return styles;
      }
      const styles = [];
      const bg = this.form.colors.buttons.bg.hex;
      const text = this.form.colors.buttons.text.hex;
      const result = this.getStyles('buttons', bg, text);
      styles.push(...result);
      return styles;
    },
    buttonClasses() {
      return {
        'k-orange-linear': this.selfService.colors.buttons.all.bg.hex === '',
        'colored-btn': this.selfService.colors.buttons.all.bg.hex !== '',
      };
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
    logo() {
      let src = '';
      if (this.companyLogo) {
        src = this.companyLogo;
      } else if (this.$auth.user().company_id !== 17322821519) {
        src = `https://files.colektia.com/company_logos/${this.$auth.user().company_id}.png`;
      } else {
        src = `https://files.colektia.com/company_logos/${this.$auth.user().company_id}.svg`;
      }
      return src;
    },
    ablePositions() {
      if (this.selfService.texts.toolbar.text !== '') {
        return this.positions.filter(item => item.value !== 'center');
      }
      return this.positions;
    },
  },
  filters: {
    formatDate(date) {
      return moment.utc(date).local().format('hh:mm A');
    },
  },
  methods: {
    clearColor(tmp, obj, field) {
      this[tmp].colors[obj][field].hex = '';
    },
    getStyles(field, bg, text) {
      const styles = [];
      if (bg !== '') {
        styles.push({
          [`--${field}-bg-color`]: bg,
        });
      }
      if (text !== '') {
        styles.push({
          [`--${field}-text-color`]: text,
        });
      }
      return styles;
    },
    filesChange(event) {
      const file = event.target.files[0];
      if (!file) {
        return false;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        this.previewFile = e.target.result;
      };
      reader.readAsDataURL(file);
      this.form.avatar.file = file;
      if (this.activeTab === '0') {
        this.companyLogo = file;
      } else {
        this.avatar = file;
      }
      return false;
    },
    clearFile() {
      const input = this.$refs.fileupload;
      input.type = 'text';
      input.type = 'file';
      this.previewFile = '';
      if (this.companyLogo) {
        this.axios.get('self-service/config/revove-image', {
          params: {
            type: 'selfService',
          },
        }).then(() => {
          this.companyLogo = '';
        });
      }
      this.form.avatar.file = {};
    },
    setColor(tmp, color, field, type) {
      this[tmp].colors[field][type].hex = `#${color}`;
    },
    setButtonColors(tmp, color, field, buttom, type) {
      this[tmp].colors[field][buttom][type].hex = `#${color}`;
    },
    sendConfig() {
      const formData = new FormData();
      formData.append('image', this.activeTab === '0' ? this.companyLogo : this.avatar);

      const config = JSON.stringify(this[this.activeTab === '0' ? 'selfService' : 'form']);
      formData.append('type', this.activeTab === '0' ? 'selfService' : 'chatbot');
      formData.append('config', config);
      this.sending = true;
      this.axios.post('self-service/config', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(({ data }) => {
        this.sending = false;
        this.snackbar.text = 'Se ha guardado la configuracion.';
        this.snackbar.color = 'success';
        this.snackbar.show = true;
        if (data.companyLogo) {
          this.companyLogo = data.companyLogo;
        }
      }).catch(() => {
        this.snackbar.text = 'Ha ocurrido un error.';
        this.snackbar.color = 'red accent-2';
        this.snackbar.show = true;
      });
    },
    setActiveBtn(value) {
      this.activeBtn = value;
    },
  },
};
</script>
<style scoped>
/* Import the Quill styles you want */
.phone-container {
  width: 300px;
  margin: 0 auto;
  display: block;
}
.phone {
  width: 300px;
  z-index: 1;
  position: absolute;
}
.chat-content {
  width: 300px;
  padding: 0 17px 4px;
  height: 541px;
}
.chat-content .toolbar {
  border-radius: 40px 40px 0 0;
  padding-left: 8px;
  padding-right: 8px;
}
.expansion-panel {
  box-shadow: 0px 0px 0px 0px transparent !important;
}
.expansion-panel .expansion-panel__container {
  position: relative;
  border-top: 0px solid transparent;
}
.drawer .toolbar {
  box-shadow: 0px 0px 0px 0px transparent !important;
}
.expansion-panel >>> .expansion-panel__header {
  position: relative;
}
.expansion-panel >>> .expansion-panel__header>:not(.header__icon){
  color: #777;
  font-weight: bold;
}
.expansion-panel >>> .expansion-panel__header::before {
  top: 50%;
  left: 65%;
  width: 30%;
  height: 2px;
  content: ' ';
  position: absolute;
  background-color: #777;
  transform: translate(-55%, -50%);
}
.color-dot {
  width: 16px;
  height: 16px;
  cursor: pointer;
  border-radius: 50%;
  display: inline-block;
}
.color-dot.active {
  width: 15px;
  height: 15px;
  border: 1px solid #333;
}
.chat-content .toolbar >>> .toolbar__title {
  font-size: 16px;
  margin-right: 16px;
}
.v-toolbar {
  height: 70px;
}

.chat-room--scrollbar {
  height: calc(100vh - 70px - 68px);
  padding-left: 4px;
  padding-right: 4px;
}
.drawer-action {
  bottom: 0;
  position: absolute;
  text-align: right;
}
.chat-room--list .v-avatar {
  min-width: 50px;
  margin-bottom: 23px;
}

.v-avatar img {
  width: 35px;
  height: 35px;
}

.grey {
  background-color:#eee !important;
}

.message-chip {
  border-radius: 0px 26px 26px;
  word-break: break-word;
}
.message-chip.reverse {
  border-radius: 26px 0px 26px 26px;
}
.clearfix {
  clear: both;
}

.writing {
  position: absolute;
  left: 20px;
  top: -20px;
}

.dot {
  display: inline-block;
  width: 2px;
  height: 2px;
  border-radius: 50%;
  margin-right: 3px;
  background: #303131;
  animation: wave 1.3s linear infinite;
}

.dot:nth-child(2) {
  animation-delay: -1.1s;
}

.dot:nth-child(3) {
  animation-delay: -0.9s;
}

#chat-actions {
  min-height: 58px;
  padding-left: 16px;
  padding-right: 16px;
}

.chat-container {
  /* height: calc(100vh - 260px); */
}
.chat-container.self-service {
  /* height: calc(100vh - 205px); */

}
.position-relative {
  position: relative;
}
.menu__content > .vc-sketch {
  width: 240px;
}
.chat-content .toolbar {
  color: var(--toolbar-text-color);
  background-color: var(--toolbar-bg-color);
}
.message-chip-text {
  color: var(--buttons-text-color) !important;
}
.message-chip-bg {
  background-color: var(--buttons-bg-color) !important;
}
.colored-btn {
  background-color: var(--buttons-bg-color) !important;
  color: var(--buttons-text-color) !important;
}
.colored-icon {
  color: var(--buttons-bg-color) !important;
}
.close {
  top: -25px;
  right: -25px;
  z-index: 100;
  position: absolute;
}
.chip-link {
  text-decoration: none;
}
.popover {
  position: absolute;
  top: -200px;
  width: 200px;
  height: 200px;
  background: #ddd;
}
.popover:after {
  height: 50px;
}
.dropbox {
  width: 100%;
  height: 200px;
  position: relative;
  border-radius: 4px;
  border: 3px dashed #aaa;
}
.dropbox input {
  width: 100%;
    height: 100%;
    opacity: 0;
}
.dropbox .caption {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}
.config-panel {
  height: 40vh;
}
.big-button {
  height: 65px;
  z-index: 100;
  position: relative;
}
.normal-button {
  z-index: 100;
  position: relative;
}
.logo {
  width: 75px;
}
.not-visible {
  opacity: 0;
}
.big-icon {
  font-size: 54px;
}
.list >>> .list__tile {
  cursor: move;
}
.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
  width: 100%;
  height: 44px;
  display: flex;
  padding-left: 14px;
  align-items: center;
  background-color: #eee;
}
.list-group-item:not(:last-child) {
  border-bottom: 1px solid rgba(0,0,0,0.1);
}
.list-group-item i {
  cursor: pointer;
}
.toolbar__title.position-center img.logo, .toolbar__title.position-center span {
  margin: 0 auto;
  display: block;
  text-align: center;
}
.toolbar__title.position-left, .toolbar__title.position-right {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.toolbar__title.position-left {
  flex-direction: row;
}
.toolbar__title.position-right {
  flex-direction: row-reverse;
}
span.position-center {
  text-align: center;
}
@keyframes wave {
	0% {
		transform: initial;
  }
  60% {
    transform: initial;
  }
  100% {
    transform: initial;
  }
	30% {
		transform: translateY(-5px);
	}
}
</style>



// WEBPACK FOOTER //
// src/components/SelfService/Index.vue